import { Component, Inject } from '@angular/core';
import { SharedCoreModule } from '@shared/modules/shared-core/shared-core.module';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss'],
  standalone: true,
  imports: [SharedCoreModule]
})
export class SessionTimeoutDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
}
